import { Component } from '@angular/core';
import { BaseViewComponent, PaymentContextScope } from '@sb/library/base';
import { PaymentProcessorType } from '@sb/library/data-models';

@Component({
    selector: 'lib-add-payment-source',
    templateUrl: './add-payment-source.component.html',
    styleUrls: ['./add-payment-source.component.scss']
})
export class AddPaymentSourceComponent extends BaseViewComponent {

    Scope = this.SetScope({
        Requires: PaymentContextScope,
    });

    get PaymentProcessorType(): typeof PaymentProcessorType {
        return PaymentProcessorType;
    }
}
